import { Injectable, Optional } from '@angular/core';
import { FrameworkVariableService } from '../frmVariableService/framework-variable.service';

@Injectable()
export class FuncsService {

    private allgspfuncs = 'allgspfuncs';
    private allfuncinvoks = 'allfuncinvoks';

    constructor(@Optional() private frmVariableService: FrameworkVariableService) {
        if (!this.frmVariableService) {
            this.frmVariableService = new FrameworkVariableService();
        }
    }

    /**
     * 缓存所有功能
     */
    public cacheAllFuncs(funcs: any[]) {
        this.frmVariableService.frameworkVariableReg(this.allgspfuncs, funcs);
    }

    /**
     * 获取所有缓存的功能
     */
    public getAllCachedFuncs(): any {
        const funcsCache = this.frmVariableService.getFrmVariableByKey(this.allgspfuncs);
        return funcsCache as any[] || [];
    }

    /**
     * 获取某功能
     */
    public getCachedFunc(funcId: string): any {
        const allfuncs = this.getAllCachedFuncs();
        if (allfuncs) {
            return allfuncs.find(f => f.id === funcId);
        }
    }

    public cacheAllFuncInvoks(invoks: any[]) {
        this.frmVariableService.frameworkVariableReg(this.allfuncinvoks, invoks);
    }

    public getAllCachedFuncInvoks(): any {
        const invokCache = this.frmVariableService.getFrmVariableByKey(this.allfuncinvoks);
        return invokCache as any[] || [];
    }

}
